var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5094 12.0666C10.2389 11.6081 9.64285 11.4445 9.16845 11.6986L7.56985 12.5541C5.98891 11.178 4.12813 8.02323 3.70106 5.99494L5.25722 5.06737C5.71884 4.79201 5.87247 4.20488 5.60203 3.74643L4.19724 1.36483C4.05263 1.12034 3.8344 0.962991 3.55345 0.90086C3.27211 0.838728 3.00618 0.888727 2.7688 1.04902L0.206757 2.77548C-1.01285 6.9817 4.46768 16.0875 8.67076 17.125L11.4796 15.8166C11.7399 15.6952 11.9172 15.4949 12.0028 15.2254C12.0884 14.9559 12.0584 14.6923 11.9142 14.4482L10.5094 12.0666Z",
    fill: "#E53323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51519 4.888L10.8283 7.78209L17.1698 3.52734H6.49341C6.68084 3.97109 6.67934 4.45748 6.51519 4.888Z",
    fill: "#004899"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9456 4.07227L11.0829 8.67738C10.9221 8.78473 10.7159 8.77627 10.5668 8.6715L6.01061 5.61417C5.92422 5.69027 5.82956 5.75975 5.72702 5.82078L4.74292 6.40717C5.26014 8.04062 6.53947 10.2097 7.7264 11.4649L8.73754 10.9237C9.64088 10.4402 10.7767 10.752 11.2917 11.6248L12.1631 13.102H13.5472H17.238H17.9667V12.3887V10.7737V4.23844C17.9655 4.18109 17.9588 4.12557 17.9456 4.07227Z",
    fill: "#004899"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.0b826414e8a3123a18a4706454e1f2a3.svg";
export { ForwardRef as ReactComponent };